import EfLink from '@elem/ui/ef-link';
import styles from './index.module.scss';
import { useRouter } from 'next/router';

const Icon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path
                d="M7.38228 10.9279C7.44218 11.0094 7.55822 11.0094 7.61811 10.9279L9.71437 8.11C9.79111 8.00659 9.72186 7.85347 9.59646 7.85347H8.20956V1.12392C8.20956 1.03642 8.14218 0.964828 8.05982 0.964828H6.93683C6.85448 0.964828 6.7871 1.03642 6.7871 1.12392V7.85148H5.40394C5.27854 7.85148 5.20929 8.0046 5.28603 8.10801L7.38228 10.9279Z"
                fill="url(#paint0_linear_4846_29957)"
            />
            <path
                d="M14.3503 10.2319H13.2273C13.1449 10.2319 13.0775 10.3035 13.0775 10.391V13.4535H1.92246V10.391C1.92246 10.3035 1.85508 10.2319 1.77273 10.2319H0.649733C0.56738 10.2319 0.5 10.3035 0.5 10.391V14.3285C0.5 14.6805 0.767647 14.9649 1.09893 14.9649H13.9011C14.2324 14.9649 14.5 14.6805 14.5 14.3285V10.391C14.5 10.3035 14.4326 10.2319 14.3503 10.2319Z"
                fill="url(#paint1_linear_4846_29957)"
            />
            <defs>
                <linearGradient id="paint0_linear_4846_29957" x1="5.25391" y1="2.3014" x2="8.74405" y2="1.91579" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#3F68E0" />
                    <stop offset="1" stopColor="#7D9DFC" />
                </linearGradient>
                <linearGradient id="paint1_linear_4846_29957" x1="0.500002" y1="10.863" x2="7.68722" y2="5.62206" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#3F68E0" />
                    <stop offset="1" stopColor="#7D9DFC" />
                </linearGradient>
            </defs>
        </svg>
    );
};
export default function BtnDownload({ text }: { text: string }) {
    const { locale = 'us' } = useRouter();
    return (
        <div className={styles.TheComp}>
            <EfLink
                href={`/${locale}/support/download/index`}
                className="comp-BtnDownload"
                dataLayer={[
                    {
                        event: 'uaEvent',
                        event_name: 'jump_button',
                        position: 'Inpage',
                        button_name: text,
                        url: 'https://www.ecoflow.com/us/support/download/index',
                    },
                ]}
            >
                <span className="comp-BtnDownload-text">{text}</span>
                <Icon />
            </EfLink>
        </div>
    );
}
